import React, { useState } from 'react';
import { Button } from '@mui/material';
import AddNotesPopup from './AddNotesPopup';

export default function AddNotesButton({ readOnly = false, addNotes, notes }) {
  const [notesPopupOpen, setNotesPopupOpen] = useState(false);

  const handleOpen = () => {
    setNotesPopupOpen(true);
  };

  const handleClose = () => {
    setNotesPopupOpen(false);
  };

  return (
    <div>
      {!readOnly && (
        <Button variant="contained" onClick={handleOpen}>
          + Add Notes
        </Button>
      )}
      <AddNotesPopup
        open={notesPopupOpen}
        onClose={handleClose}
        addNotes={addNotes}
        readOnly={readOnly}
        initialData={{ notes }}
      />
    </div>
  );
}
